
import React ,{useState,useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import loader from '../../assets/Images/loader.gif';
import { toast } from 'react-toastify';


const BroadbandLead = () => {
  const [loading, setLoading] = useState(false);
  const [flagAll,setFlagAll]=useState(false);
  const [flagOpen,setFlagOpen]=useState(false);
  const [flagQualified,setFlagQualified]=useState(false);
  const [flagDisQualified,setFlagDisQualified]=useState(false);
  const [leadDataAll, setLeadDataAll] = useState([]);
  const [leadDataOpen, setLeadDataOpen] = useState([]);
  const [leadDataQualified, setLeadDataQualified] = useState([]);
  const [leadDataDisQualified, setLeadDataDisQualified] = useState([]);
  const [searchInputAll, setSearchInputAll] = useState('');
  const [searchInputOpen, setSearchInputOpen] = useState('');
  const [searchInputQualified, setSearchInputQualified] = useState('');
  const [searchInputDisQualified, setSearchInputDisQualified] = useState('');
  const [searchFilter, setSearchFilter] = useState([]);

  useEffect(() => {
    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toISOString().split('T')[0]; 
    const toDate = formattedCurrentDate;
    const fromDate = new Date(currentDate);
    fromDate.setMonth(currentDate.getMonth() - 2);
    const formattedFromDate = fromDate.toISOString().split('T')[0];

   const fetchData = async () => {
       try {
         setLoading(true);
         const apiUrl = process.env.REACT_APP_API_URL;
         const requestData = {
        "Action": "getAllLeads",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Home",
        "fromDate": formattedFromDate,
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": "",
        "status": "All",
        "toDate": toDate,
        "userName": sessionStorage.getItem('userName'),
        };
         const response = await fetch(apiUrl, {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
           },
           body: JSON.stringify(requestData),
         });
         if (response.ok) {
           const result = await response.json();
           //console.log('API Response:', result);
           if (result && result.Response && result.Response.Status !== "Failure" && result.Response.Data !== undefined) {
            //  console.log('Actual Data:', result.Response.Data);
             setLeadDataAll(result.Response.Data);
           } else {
             const errorMessage = (result && result.Response && result.Response.Message);
          //    toast.warning(`${errorMessage}`, {
          //      position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          //  });
           }
         } else {
           console.error('Error fetching data:', response.status);
         }
       } catch (error) {
         console.error('Error fetching data:', error);
       } finally {
         setLoading(false);
       }
     };
   fetchData();
 }, []);

 useEffect(() => {
  const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Action": "getAllLeads",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "businessSegment": "Home",
          "fromDate": "",
          "password": sessionStorage.getItem('password'),
          "searchBoxValue": "",
          "status": "Open",
          "toDate": "",
          "userName": sessionStorage.getItem('userName'),
          }
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          //console.log('API Response:', result);
          
          if (result && result.Response && result.Response.Status !== "Failure" && result.Response.Data !== undefined) {
            //console.log('Actual Data:', result.Response.Data);
            setLeadDataOpen(result.Response.Data);
          } else {
            const errorMessage = (result && result.Response && result.Response.Message);
          //   toast.warning(`${errorMessage}`, {
          //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          // });
          }
        } else {
          console.error('Error fetching data:', response.status);
          
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
  fetchData();
}, []);

useEffect(() => {
  const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Action": "getAllLeads",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "businessSegment": "Home",
          "fromDate": "",
          "password": sessionStorage.getItem('password'),
          "searchBoxValue": "",
          "status": "Qualified",
          "toDate": "",
          "userName": sessionStorage.getItem('userName'),
          }
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          //console.log('API Response:', result);
          
          if (result && result.Response && result.Response.Status !== "Failure" && result.Response.Data !== undefined) {
            //console.log('Actual Data:', result.Response.Data);
            setLeadDataQualified(result.Response.Data);
          } else {
            const errorMessage = (result && result.Response && result.Response.Message);
          //   toast.warning(`${errorMessage}`, {
          //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          // });
          }
        } else {
          console.error('Error fetching data:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
  fetchData();
}, []);

useEffect(() => {
  const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData ={
          "Action": "getAllLeads",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "businessSegment": "Home",
          "fromDate": "",
          "password": sessionStorage.getItem('password'),
          "searchBoxValue": "",
          "status": "Disqualified",
          "toDate": "",
          "userName": sessionStorage.getItem('userName'),
          }
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          //console.log('API Response:', result);
          
          if (result && result.Response && result.Response.Status !== "Failure" && result.Response.Data !== undefined) {
            //console.log('Actual Data:', result.Response.Data);
            setLeadDataDisQualified(result.Response.Data);
          } else {
            const errorMessage = (result && result.Response && result.Response.Message);
          //   toast.warning(`${errorMessage}`, {
          //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          // });
          }
        } else {
          console.error('Error fetching data:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
  fetchData();
}, []);

const handleSearchAll = async () => {
  try {
    setLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    const requestData = {
      "Action": "getAllLeads",
      "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      "businessSegment": "Home",
      "fromDate": "",
      "password": sessionStorage.getItem('password'),
      "searchBoxValue": searchInputAll,
      "status": "All",
      "toDate": "",
      "userName": sessionStorage.getItem('userName'),
      }
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagAll(true);
    } else {
      // console.error("Error fetching data:", response.status);
      const errorMessage = (result && result.Response && result.Response.Message);
             toast.warning(`${errorMessage}`, {
               position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
           });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};

const handleSearchOpen = async () => {
  try {
    setLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    const requestData = {
      "Action": "getAllLeads",
      "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      "businessSegment": "Home",
      "fromDate": "",
      "password": sessionStorage.getItem('password'),
      "searchBoxValue": searchInputOpen,
      "status": "Open",
      "toDate": "",
      "userName": sessionStorage.getItem('userName'),
      }
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagOpen(true);
    } else {
      // console.error("Error fetching data:", response.status);
      const errorMessage = (result && result.Response && result.Response.Message);
             toast.warning(`${errorMessage}`, {
               position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
           });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};


const handleSearchQualified = async () => {
  try {
    setLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    const requestData = {
      "Action": "getAllLeads",
      "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      "businessSegment": "Home",
      "fromDate": "",
      "password": sessionStorage.getItem('password'),
      "searchBoxValue": searchInputQualified,
      "status": "qualified",
      "toDate": "",
      "userName": sessionStorage.getItem('userName'),
      };
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagQualified(true);
    } else {
      // console.error("Error fetching data:", response.status);
      const errorMessage = (result && result.Response && result.Response.Message);
             toast.warning(`${errorMessage}`, {
               position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
           });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};

const handleSearchDisQualified = async () => {
  try {
    setLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    const requestData = {
      "Action": "getAllLeads",
      "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      "businessSegment": "Home",
      "fromDate": "",
      "password": sessionStorage.getItem('password'),
      "searchBoxValue": searchInputDisQualified,
      "status": "Disqualified",
      "toDate": "",
      "userName": sessionStorage.getItem('userName'),
      };
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagDisQualified(true);
    } else {
      // console.error("Error fetching data:", response.status);
      const errorMessage = (result && result.Response && result.Response.Message);
             toast.warning(`${errorMessage}`, {
               position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
           });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};

const navigate = useNavigate();
  const updateLeadForm=(LeadId)=>{
    //console.log(LeadId);
    navigate(`/broadbandLeadForm?LeadId=${LeadId}`);
  }

    const redirectBroadbandPage = () => {
      navigate("/broadband");
    };
    const redirectBroadbandLeadForm = () => {
      navigate("/broadbandLeadForm");
    };
  return (
    <>
         <div className="container-fluid text-light Header-style header">
              <div className="p-3">
                  <span className="" style={{ cursor: "pointer" }} onClick={redirectBroadbandPage}>
                    <i className="fa-solid fa-arrow-left-long"></i>
                </span>
                <span className="p-1 m-3">Broadband Leads</span>
              </div>
                  {/* Navigation tabs: ALL , OPEN , QUALIFIED , DISQUALIFIED */}
                <div className="scrollable-tabs">
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <a className="nav-link active" data-bs-toggle="tab" href="#all">All</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-bs-toggle="tab"  href="#open">Open</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-bs-toggle="tab" href="#qualified">Qualified</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-bs-toggle="tab" href="#disqualified">Disqualified</a>
                    </li>
                  </ul>
                </div>
            </div>

            <div className="tab-content tab-main-content">
              {/* ****************** ALL lead TAB ************* */}
              <div className="tab-pane fade show active" id="all">
              <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                  <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                      <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} 
                      value={searchInputAll} onChange={(e) => setSearchInputAll(e.target.value)}  />
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearchAll}>Search</button>
                  </div>
                </div>

                {/* ***********All content of ALL lead Tab************ */}

                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                 !flagAll && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 card-container">
                    {leadDataAll.map((lead, index) => (
                      
                    <div className="col" key={index} >
                      <div className="card mb-3">
                        <div className="m-2 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  ))}
                </div>
              </div>)
            )}

              
            {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flagAll && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((lead, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3">
                        <div className="m-3 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}


              </div>

                {/* ****************** close lead TAB ************* */}
              <div className="tab-pane fade show" id="open">
                <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                  <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                      <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputOpen}
              onChange={(e) => setSearchInputOpen(e.target.value)} />
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearchOpen}>Search</button>
                  </div>
                </div>

                {/* ***********All content of open lead Tab************ */}

                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                 !flagOpen && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 card-container">
                    {leadDataOpen.map((lead, index) => (
                      
                    <div className="col" key={index} >
                      <div className="card mb-3">
                        <div className="m-2 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  ))}
                </div>
              </div>)
            )}
              
              
            {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flagOpen && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((lead, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3">
                        <div className="m-3 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}

              </div>

              {/* ****************** qualified lead TAB ************* */}
              <div className="tab-pane fade show" id="qualified">
                <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                  <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                      <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputQualified}
              onChange={(e) => setSearchInputQualified(e.target.value)}/>
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearchQualified}>Search</button>
                  </div>
                </div>

                {/* ***********All content of qualified lead Tab************ */}


                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                 !flagQualified && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {leadDataQualified.map((lead, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3">
                        <div className="m-2 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}
                

            {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flagQualified && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((lead, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3">
                        <div className="m-3 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}

              </div>

              {/* ****************** disqualified lead TAB ************* */}
              <div className="tab-pane fade show" id="disqualified">
              <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                  <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                      <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputDisQualified}
              onChange={(e) => setSearchInputDisQualified(e.target.value)}/>
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearchDisQualified}>Search</button>
                  </div>
                </div>

                {/* ***********All content of disqualified lead Tab************ */}

                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                 !flagDisQualified && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {leadDataDisQualified.map((lead, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3">
                        <div className="m-2 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}

            {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flagDisQualified && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((lead, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3">
                        <div className="m-3 card-data" style={{ display: "inline-flex" }} onClick={() => updateLeadForm(lead.LeadId)}>
                          <div>
                          <p className="lead-card-title">{lead.LeadName} ({lead.LeadId})</p>
                          <p className="lead-card-text">Mobile No : {lead.MobileNumber}</p>
                          <p className="lead-card-text">Email ID : {lead.EmailId}</p>
                          <p className="lead-card-text">Status : {lead.Status}</p>
                          <p className="lead-card-text">Created on : {lead.Createdon}</p>
                          <p className="lead-card-text">Created By : {lead.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}


              </div>
            </div>

            {/* ***********************  Add Icon************************** */}
      <div className='position-fixed bottom-0 end-0 m-4' >
        <span className='bg-dark rounded-circle faPlus-icon' onClick={redirectBroadbandLeadForm}>
          <i className="fa-solid fa-plus fa-lg text-light m-1"></i>
        </span>
      </div>
    </>
  )
}

export default BroadbandLead
